import { ColorBoxInner } from './colorBoxInner'
import { SystemStyleObject } from '@styled-system/css'
import React from 'react'

interface ColorBoxProps {
  className?: string
  id?: string
  onMouseOver?: () => void
  onMouseLeave?: () => void
  onClick?: () => void
  src: string
  alt?: string
  sx?: SystemStyleObject
  selectedValue?: string
  value: string
  currentlyNotInStock?: boolean
}

export const ColorBoxV2 = ({
  className,
  sx,
  selectedValue,
  currentlyNotInStock,
  value,
  ...props
}: ColorBoxProps): JSX.Element => {
  return (
    <ColorBoxInner
      className={`color-box ${className}`}
      id={`${String(value)}`}
      data-selected={value === selectedValue}
      sx={{
        borderColor:
          currentlyNotInStock && value !== selectedValue
            ? '#DCDCDC'
            : value === selectedValue
            ? 'txt'
            : 'bg',
        position: 'relative',
        overflow: 'hidden',
        ...sx,
        '&::after': {
          content: '""',
          display: currentlyNotInStock ? 'block' : 'none',
          position: 'absolute',
          right: '0',
          bottom: '0',
          zIndex: '1',
          opacity: '1',
          width: '90px',
          backgroundColor: value === selectedValue ? 'txt' : '#DCDCDC',
          transform: 'rotate(-45deg)',
          height: '2px',
          top: '29.4px',
          left: '-17px',
          '@media screen and (max-width: 640px)': {
            width: '50px',
            top: '12px',
            left: '-9px',
          },
        },
      }}
      alt={String(value)}
      {...props}
    />
  )
}
